export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13807.e6ebe98f.jpg";